<template>
  <div
    class="board-preview-item"
    :class="{ 'is-selected': isSelected }"
    @click="handleClick"
  >
    <BoardSnapshot :pgn="scenario.pgn" :board-size="boardSize" />
    <div class="preview-label">
      {{ index + 1 }}.
      {{ scenario.title || (scenario.isPuzzle ? "Puzzle" : "Example") }}
      <template v-if="scenario.isPuzzle">🧩</template>
      <template v-if="scenario.isHomework">📚</template>

      <div class="preview-details">
        <span v-if="getMoveCount(scenario)" class="move-count">
          <b-icon icon="chess-pawn" size="is-small" />
          {{ getMoveCount(scenario) }} moves
          <span v-if="getMovesPreview(scenario)" class="moves-preview">
            {{ getMovesPreview(scenario) }}
          </span>
        </span>

        <PuzzleLevelBadge
          v-if="scenario.puzzleLevel"
          :level="scenario.puzzleLevel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BoardSnapshot from "@/components/training/explorer/molecules/BoardSnapshot.vue";
import PuzzleLevelBadge from "@/components/training/explorer/atoms/PuzzleLevelBadge";
import { PgnParser } from "vue-chess-shared/pgn/PgnParser";

export default {
  name: "BoardPreview",

  components: {
    BoardSnapshot,
    PuzzleLevelBadge,
  },

  props: {
    scenario: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    boardSize: {
      type: Number,
      default: 176,
    },
  },

  methods: {
    handleClick() {
      this.$emit("click", this.scenario.id);
    },

    getMoveCount(scenario) {
      if (!scenario.pgn) return 0;
      return PgnParser.getMoveCount(scenario.pgn);
    },

    getMovesPreview(scenario) {
      if (!scenario.pgn) return "";
      if (this.getMoveCount(scenario) === 0) return "";
      if (scenario.isPuzzle) return "";

      try {
        const { moves } = PgnParser.splitHeadersAndMoves(scenario.pgn);
        // Return first 10 characters
        return moves.substring(0, 10) + (moves.length > 10 ? "..." : "");
      } catch (error) {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.board-preview-item {
  flex: 0 0 calc(33.333% - 1rem);
  min-width: 200px;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s;
  padding: 8px;
  border-radius: 6px;
}

.board-preview-item:hover {
  background-color: rgba(0, 209, 178, 0.05);
  box-shadow: 0 0 0 2px #34369e;
  transform: translateY(-2px);
}

.board-preview-item.is-selected {
  background-color: #f0f8ff; /* Light blue background */
  box-shadow: 0 0 0 2px #3273dc; /* Buefy blue border */
}

.preview-label {
  margin-top: 0.5rem;
  text-align: center;
  font-size: 0.9rem;
  width: 100%;
  min-height: 2.4em; /* Accommodate up to 2 lines */
  overflow: hidden;
  word-break: break-word;
}

.preview-details {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
}

.move-count {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #666;
}

.moves-preview {
  color: #999;
  margin-left: 0.25rem;
}

@media screen and (max-width: 768px) {
  .board-preview-item {
    flex: 0 0 calc(50% - 1rem);
  }
}

@media screen and (max-width: 480px) {
  .board-preview-item {
    flex: 0 0 100%;
  }
}
</style>
